import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import debounce from 'lodash/debounce';
import { Card, Grid } from '@mui/material';
import ActionsPopover from 'components/ActionsPopover/ActionsPopover';

import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDTypography from 'components/MDTypography';
import DataTable from 'examples/Tables/DataTable';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {
  getNotificationsList,
  addSms
} from '../../store/reducers/usersSlice';
import { smsColumns } from 'constants/columns.constants';
import AddSms from 'layouts/sms/components/AddSms'
import moment from 'moment'
import { toast } from 'react-toastify';

const Sms = () => {
  const [isLoading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const { notifications } = useSelector((state) => state.usersSlice);
  const [selectedEmail, setSelectedEmail] = useState(null);

  const [openModal, setOpenModal] = useState(false);
  const [isPreviewModal, setPreviewModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const columns = useMemo(() => {
    return smsColumns;
  }, []);

  const rows =
  notifications?.notificationsData?.length > 0
      ? notifications?.notificationsData?.map((sms) => {
          return {
            id:sms?.id,
            body: (
              <div style={{ maxWidth: 'max(calc(100vw - 650px), 20ch)' }}>
                {sms?.body?? 'NA'}
              </div>
            ),
            date:(
              <div>
                {moment(sms?.date?? 'NA').format('MM/DD/YYYY h:mm a')}
              </div>
            ),
            priorityIndex: sms?.priorityIndex ?? 'NA',
            actions: (
              <ActionsPopover
                viewTitle={'View Sms'}
                onViewClick={() => {
                  setSelectedEmail(sms);
                  setPreviewModal(true);
                }}
              />
            ),
          };
        })
      : [];

  async function fetchSmsList() {
    try {
      setLoading(true);
      await dispatch(
        getNotificationsList({
          page: currentPage + 1,
          limit: perPage,
          type:'sms'
        })
      );
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }

  const onCloseModal = () => {
    setSelectedEmail(null);
    setOpenModal(false);
    setPreviewModal(false);
  };

  const onCreateSms = async (data) => {
    try {
      await dispatch(
        addSms({
          ...data,
        })
      );
      toast.success(data?.message)
      onCloseModal();
      if (currentPage === 0) {
        fetchSmsList();
      } else {
        setCurrentPage(0);
      }
    } catch (error) {
    }
  };

  const onFetchDataDebounced = debounce(fetchSmsList, 0);

  useEffect(() => {
    onFetchDataDebounced();
    return () => {
      onFetchDataDebounced.cancel();
    };
  }, [currentPage, perPage]);

  return (
    <MDBox pt={6} pb={3}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                SMS
              </MDTypography>
              <MDButton
                sx={{ marginLeft: 'auto', marginRight: '16px' }}
                variant="outlined"
                startIcon={<AddCircleOutlineIcon />}
                onClick={() => setOpenModal(true)}
              >
                Add Sms
              </MDButton>
            </MDBox>
            <MDBox
              sx={{
                position: 'relative',
                paddingTop: '85px',
                paddingBottom: {
                  xs: '150px',
                  sm: '95px',
                },
              }}
            >
              <DataTable
                table={{ columns, rows }}
                isSorted={true}
                entriesPerPage={{ defaultValue: perPage }}
                showTotalEntries
                perPage={perPage}
                setPerPage={setPerPage}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPage={notifications?.totalPage}
                totalRecords={notifications?.totalCount}
                // hiddenColumns={['id']}
                isLoading={isLoading}
              />
            </MDBox>
          </Card>
        </Grid>
      </Grid>
      {openModal && (
        <AddSms
          openModal={openModal}
          onCloseModal={onCloseModal}
          onCreateSms={onCreateSms}
        />
      )}
    </MDBox>
  );
};

export default Sms;
